import { Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { ArtistStatement } from '../../services/artist-statement.service';

@Component({
  selector: 'app-artist-statement-template',
  standalone: true,
  imports: [CommonModule, CurrencyPipe, DatePipe],
  templateUrl: './artist-statement-template.component.html',
  styleUrls: ['./artist-statement-template.component.css']
})
export class ArtistStatementTemplateComponent {
  @Input() statement!: ArtistStatement;
  @Input() forPdf: boolean = false;
  // KAN-147 (automated monthly statements); manual statements leave this at its default
  /** The artist has no usable commission: amounts read "Rate missing". */
  @Input() rateMissing = false;
  today = new Date();
}
